<script setup lang="ts">
import Translator from "@/utils/common/Translator.ts";
import TopPanelSearchUtils, {SearchItem} from "@/utils/common/TopPanelSearchUtils.ts";
import {PropType, ref} from "vue";
import {StringUtils} from "@/utils/common/StringUtils.ts";
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
const {compactMode} = storeToRefs(useNamaFlagsStore());
let model = defineModel({
  type: Object as PropType<SearchItem | null>
});
let qSelectModel = ref<string | null | undefined>(model.value?.text);
let allEntities = TopPanelSearchUtils.fetchEntitiesForSearchIn();
let options = ref<SearchItem[]>([]);

function filter(value: string | null | undefined) {
  if (!value) {
    options.value = [];
    return;
  }
  options.value = allEntities.filter(e =>
    e.searchData && (e.searchData.includes(value)
      || e.searchData.includes(StringUtils.normalizeArabic(value))
      || e.searchData.includes(StringUtils.normalizeArabic(StringUtils.englishToArabic(value)))
      || e.searchData.includes(StringUtils.arabicToEnglish(value).toLowerCase())))
    .sort((a, b) => a.id === b.id ? 0 : a.searchData!.length - b.searchData!.length);
}

function onFilter(val, update) {
  update(() => filter(val),
    ref => {
      if (val !== '' && ref.options.length > 0) {
        ref.setOptionIndex(-1) // reset optionIndex in case there is something selected
        ref.moveOptionSelection(1, true) // focus the first selectable option and do not update the input-value
      }
    })
}

function setModel(val) {
  if (!val)
    model.value = null;
  qSelectModel.value = val;
}

function onSelect(value: SearchItem) {
  model.value = value;
}
</script>

<template>
  <div class="tw-mb-0" id="header-search-in-popup-container">
    <div class="tw-relative tw-leading-tight">
      <q-select
        filled use-input hide-selected fill-input dense :options-dense="compactMode"  hide-dropdown-icon
        input-debounce="0"
        clearable
        @clear="()=>{setModel(null)}"
        :model-value="qSelectModel"
        :options="options"
        option-label="text"
        @filter="onFilter"
        @input-value="setModel"
        @update:model-value="onSelect"
        :placeholder="Translator.translateId('entityTypeDF')"
        class="tw-bg-[#F8F9FA] tw-shadow tw-appearance-none dark:tw-bg-[#3E3E3E]"
        input-class="tw-bg-transparent tw-px-0 focus:tw-ring-0 focus:tw-shadow-none focus:tw-border-none dark:tw-text-namaFontColor-input-dark
         dark:tw-placeholder-gray-300 header-search-in-popup-input"
        popup-content-class="navbar-search-popup dark:tw-bg-namaBackground-deep-dark dark:tw-text-white">
      </q-select>
    </div>
  </div>
</template>

<style>
#header-search-in-popup-container .q-field__append .q-icon {
  @apply dark:tw-text-white
}
</style>
